import moment from 'dayjs'
import { ServerFirebaseUser } from '../types/ServerTypes.js'
import { BaseObject } from '../types/types.js'
import { createUniqueId } from './Common.js'
import invariant from 'invariant'

// eslint-disable-next-line prettier/prettier
export const toUpdatedObject = <T extends BaseObject>(object: T, _u?: ServerFirebaseUser): T => ({
  ...object,
  updatedAt: moment().format()
})

type MapFunction = (item: any) => any

export const mapQueryResponse = (response: any, mapFn?: MapFunction) =>
  response.docs ? getCollectionData(response, mapFn) : getDocData(response, mapFn)

// Get array of doc data from collection
export const getCollectionData = (collection: any, mapFn?: MapFunction) =>
  collection.docs.map((doc: any) => getDocData(doc, mapFn))

// Get doc data and merge doc.id
export function getDocData(doc: any, mapFn?: MapFunction) {
  if (!doc.exists) return null
  const data = { id: doc.id, ...doc.data() }
  return mapFn ? mapFn(data) : data
}

export const toBaseObject = (): BaseObject => {
  const id = createUniqueId()
  return {
    id,
    createdAt: moment().format()
  }
}

export const assertNotMultipleDocs = <T>(docs: Array<T>, errorMessage = 'Found Multiple documents'): T | undefined => {
  invariant(docs.length <= 1, errorMessage)
  return docs[0]
}
